import { use, useEffect } from 'react'

import { HeaderContext } from '@/context/Header'
import { useCandidate } from '@/react-query/candidate'
import { useInterview } from '@/react-query/interview/interview'
import { useRole } from '@/react-query/role'
import { DynamicHeader } from '@/views/screens/Interview/components/DynamicHeader/DynamicHeader'
import { useAudioRecorder } from '@/views/screens/Interview/context/AudioRecorderContext/AudioRecorderContext'

import { InterviewDataContext } from '../context'

export const useDynamicHeader = () => {
  const candidate = useCandidate()
  const role = useRole()
  const interview = useInterview()
  const { setMiddleContent } = use(HeaderContext)
  const { isFileUploading, fileUploadProgress } = use(InterviewDataContext)
  const { isRecording, stopRecordingNoUpload } = useAudioRecorder()

  useEffect(() => {
    setMiddleContent(
      <DynamicHeader
        role={role.data}
        candidate={candidate.data}
        interview={interview.data}
        isLoadingExistingInterview={interview.isLoading || candidate.isLoading}
        isRecording={isRecording}
        isFileUploading={isFileUploading}
        fileUploadProgress={fileUploadProgress}
        stopRecordingNoUpload={stopRecordingNoUpload}
      />,
    )
    // Reset when unmounting
    return () => setMiddleContent(null)
  }, [
    candidate.data?.fullName,
    role.data?.jobTitle,
    isRecording,
    isFileUploading,
    interview.data,
    fileUploadProgress,
    stopRecordingNoUpload,
  ])
}
